module.exports = __webpack_public_path__ + "static/media/refreshMLR.87bdfea5.svg";